import { isEmpty } from 'lodash'
import React from 'react'
import { SignalAssessmentsViewList } from 'scenes/Dashboard/components/SignalAssessmentsViewList'
import { SignalAssessment } from 'scenes/Dashboard/data/signalAssessments/types'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import SectionHeader from '../SectionHeader'

type SignalsProps = { signals: SignalAssessment[] }

export const Signals = React.memo(({ signals }: SignalsProps) => {
  const { classes } = useStyles()
  return !isEmpty(signals) ? (
    <section className={classes.container}>
      <SectionHeader text="Signals" />
      <SignalAssessmentsViewList signalAssessments={signals} />
    </section>
  ) : null
})

Signals.displayName = 'Signals'

const useStyles = makeStyles()(({ spacing, typography }: Theme) => ({
  container: {
    marginBottom: spacing(2),
    marginTop: spacing(2),
  },
  summary: {
    fontWeight: typography.fontWeightBold,
  },
}))
